// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { ImageFit } from "../components/ImageFit"
import { Layout } from "../components/Layout"
import { tRouteProps, tDefaultTemplate } from "../types"
import { Container } from "../components/StyledComponents"
import { PageMeta } from "../components/PageMeta"
import { css } from "../../node_modules/emotion"
import { mq } from "../styles/variables"
import { setHtml } from "../utils"

type tPerson = {
  title: {
    rendered: string
  }
}

function Person(props: tPerson & tRouteProps & tDefaultTemplate) {
  return (
    <Container
      className={css`
        section {
          padding-top: 60px;
        }

        .title-wrapper {
          display: flex;
          flex-direction: column;
          margin-bottom: 30px;
          flex-wrap: wrap;

          h1 {
            margin-bottom: 10px;
          }

          > * {
            margin: 0;
            line-height: 32px;
          }
        }

        .img-wrapper {
          width: 450px;
          margin-left: auto;
          margin-right: auto;

          img {
            max-width: 100%;
            min-width: 100%;
            margin-bottom: 15px;
          }
        }

        ${mq.md(css`
          .row {
            display: flex;
          }

          .content {
            flex-grow: 1;
          }

          .img-wrapper {
            min-width: 300px;
            width: 300px;
            margin: 0 30px 0 0;

            img {
              margin: 0;
            }
          }
        `)};
      `}
    >
      <PageMeta
        title={props.title}
        description={props.title + " " + props.person_content.title}
        image={props.person_content.headshot}
      />
      <section>
        <div className="title-wrapper">
          <h1 className="h2">{props.title}</h1>
          <span className="h3">{props.person_content.title}</span>
        </div>
        <div className="row">
          <div className="img-wrapper">
            <ImageFit
              src={props.person_content.headshot.url}
              alt={props.person_content.headshot.alt}
            />
          </div>
          <div className="content" {...setHtml(props.person_content.content)} />
        </div>
      </section>
    </Container>
  )
}

function RenderPerson(props: tPerson) {
  return (
    <Layout>{(routeProps) => <Person {...props} {...routeProps} />}</Layout>
  )
}

export default hot(module)(RenderPerson)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Person.js